import { createPortal } from 'react-dom';

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import cn from 'classnames';
import AffiliatesContent from 'components/AffiliatesContent/AffiliatesContent';
import {
  getAmazonLensApiUrl,
  mergeTabsAndRemoveDuplicateProducts,
  modifyResponseForProductList,
} from './Util';

import s from './STLButton.scss';
import analyticsWrapper from '../../../../helpers/analytics/analyticsWrapper';

const StlButton = props => {
  const buttonRef = useRef(null);
  const { imageMsid, index } = props;
  const [isProcessed, setIsProcessed] = useState(false);
  const [productsData, setProductsData] = useState();
  const [showOverlay, setShowOverlay] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const rootMargin = {
    rootMargin: '400px 0px 400px 0px',
  };
  const ga4 = { type: 'shop_the_look', story_no: index, label: imageMsid };

  const fetchProductsData = async refresh => {
    try {
      const headers = refresh ? { fref: 1 } : undefined;
      const res = await Axios.post(getAmazonLensApiUrl(imageMsid), null, {
        headers,
      });
      const { status, data = {} } = res;
      if (status === 200) {
        const { shopTheLook: { searchResult = [] } = {} } = data;
        if (searchResult.length) {
          const result = modifyResponseForProductList(searchResult);
          mergeTabsAndRemoveDuplicateProducts(result);
          setProductsData(result);
          if (!productsData) {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              ...ga4,
            });
          }
        }
      }
    } catch (error) {
      console.log('Error:STL:', error);
    }
  };

  useEffect(() => {
    const { current } = buttonRef;
    if (current) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const { isIntersecting } = entry;
          if (isIntersecting && !isProcessed) {
            setIsProcessed(true);
            fetchProductsData();
          }
        });
      }, rootMargin);
      observer.observe(current);
    }
  }, []);

  const buttonClass = cn({
    [s.shopBtn]: !!productsData,
  });

  const loaderClass = cn({
    [s.loader]: showLoader,
  });

  const renderSTLOverlay = () => {
    let portalElement = document.getElementById('affiliate_stl_overlay');
    if (!portalElement) {
      portalElement = document.createElement('div');
      portalElement.setAttribute('id', 'affiliate_stl_overlay');
      portalElement.style.position = 'fixed';
      portalElement.style.zIndex = 999999;
      portalElement.style.top = 0;
      document.body.appendChild(portalElement);
    }
    portalElement.addEventListener('click', event => {
      const { target: { dataset } = {} } = event;
      if (dataset.aff_cross) {
        setShowOverlay(false);
      }
    });
    return createPortal(
      <div id="affiliateShopTheLookOverlay">
        <AffiliatesContent
          enableWidgetsOnLoad
          loadingComponent={<></>}
          type="stl_overlay"
          filters={{
            pagename: 'photostory',
          }}
          onContentLoaded={() => {
            setShowLoader(false);
          }}
          componentProps={{
            config: {
              ga4,
            },
            data: productsData.data,
          }}
        />
      </div>,
      portalElement,
    );
  };

  return (
    <>
      <div
        onClick={() => {
          analyticsWrapper('ga4', {
            event: 'user_click',
            ...ga4,
            category: 'shop similar look',
          });
          setShowLoader(true);
          fetchProductsData(true);
          setShowOverlay(true);
        }}
        className={buttonClass}
        ref={buttonRef}
      >
        {!!productsData && 'shop similar look'}
        <span className={loaderClass} />
      </div>
      {showOverlay && renderSTLOverlay()}
    </>
  );
};

StlButton.propTypes = {
  imageMsid: PropTypes.string,
  index: PropTypes.number,
};

StlButton.defaultProps = {
  imageMsid: '',
  index: 0,
};
export default StlButton;
